import {FormattedMessage} from 'react-intl';

import {type PluginComponent} from 'types/store/plugins';
import {type FileInfo} from '@mattermost/types/files';
import Menu from 'components/widgets/menu/menu';

import type {Props} from 'components/file_upload/types';

export const getPluginItems = (
    pluginMenuItems: PluginComponent[],
    pluginItemProps: {
        getPostText: () => string;
        getPostFiles: () => FileInfo[];
        clearPost: () => Promise<boolean>;
        rootId?: string;
    },
) => {
    return (
        pluginMenuItems
            .map((item) => {
                if (item.subMenu) {
                    return (
                        <Menu.ItemSubMenu
                            extraBottomOffset={60}
                            key={item.id + '_pluginmenuitem'}
                            id={item.id}
                            actionProps={pluginItemProps}
                            text={item.text}
                            subMenu={item.subMenu}
                            hoverDisabled={item.hoverDisabled}
                            action={item.action}
                            root={true}
                        />
                    );
                }
                return (
                    <Menu.ItemAction
                        key={item.id + '_pluginmenuitem'}
                        text={item.text}
                        hoverDisabled={item.hoverDisabled}
                        onClick={() => {
                            if (item.action) {
                                item.action(pluginItemProps);
                            }
                        }}
                    />
                );
            })
    );
};

export type SpecialMentions = ReturnType<typeof getSpecialMentions>;
export const getSpecialMentions = () => {
    const hereDN = (
        <FormattedMessage
            id='suggestion.mention.here'
            defaultMessage='Notify everyone online in this chat'
        />
    );

    const channelDM = (
        <FormattedMessage
            id='suggestion.mention.channel'
            defaultMessage='Notify everyone in this chat'
        />
    );

    const allDM = (
        <FormattedMessage
            id='suggestion.mention.all'
            defaultMessage='Notify everyone in this chat'
        />
    );

    return {
        here: {
            type: 'custom' as const,
            displayName: hereDN,
            handle: 'here',
            label: 'here',
            id: 'here',
        },
        channel: {
            type: 'custom' as const,
            displayName: channelDM,
            handle: 'channel',
            label: 'channel',
            id: 'channel',
        },
        all: {
            type: 'custom' as const,
            displayName: allDM,
            handle: 'all',
            label: 'all',
            id: 'all',
        },
    };
};

export const getStatusFromSlashCommand = (message: string) => {
    const tokens = message.split(' ');

    return tokens[0]?.substring(1);
};

export const STATUS_SLASH_COMMANDS = ['online', 'away', 'dnd', 'offline'];

export const isStatusSlashCommand = (command?: string) => {
    // @TODO: вынести наверх

    if (!command) {
        return false;
    }

    return STATUS_SLASH_COMMANDS.includes(command);
};

export const getPostType = (
    isThread: boolean,
    isThreadView?: boolean,
): Props['postType'] => {
    if (isThread && !isThreadView) {
        return 'comment';
    } else if (isThreadView) {
        return 'thread';
    }
    return 'post';
};
